import { FileText } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgNotesPaper = mkIcon(FileText);